<template>
  <div>
    <div class="title">{{ $t('PEDIDO_confirmar_title') }}</div>

    <el-row v-if="pedido !== undefined">

      <!-- CABECERA -->
      <el-col class="container_col_1" :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
        <div class="contenedores">
          <el-card>
            <div class="card_body cabecera">
              <el-row>
                <el-col :span="24">
                  <div class="subtitulo">{{ $t('PEDIDO_numero_pedido') }}</div>
                  <div class="sub-title">{{ pedido.Numero }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="subtitulo">{{ $t('PERFIL_empresa') }}</div>
                  <div class="sub-title">{{ pedido.Empresa }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('PEDIDO_instancia')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel">{{ descripcionInstancia }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('GENERAL_fecha')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel">{{ pedido.FechaStr }}</div>
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 10px">
                <el-col :span="10">
                  <div class="label">{{$t('PEDIDO_plazo_pago')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel">{{ pedido.PlazoPago.Descripcion }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('PEDIDO_nota_comercial')}}:</div>
                </el-col>
                <el-col :span="14">
                  <div class="greyLabel">{{ pedido.NotaComercial }}</div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
      </el-col>

      <!-- TOTALES -->
      <el-col class="container_col_2" :xs="24" :sm="24" :md="17" :lg="17" :xl="17">
        <div class="contenedores">
          <el-card :body-style="{ padding: '0px' }">
            <el-row class="detalle_pedido">
              <el-col :span="2">
                <div :class="opened ? 'triangleDown' : 'triangleRight'" v-on:click="toggleOpen"></div>
              </el-col>
              <el-col :span="15" class="subtitulo">{{$t('PEDIDO_detalles')}}</el-col>
            </el-row>
            <el-divider></el-divider>
            <transition name="fade">
              <div v-show="opened" >
                <el-row>
                  <el-col :span="24">
                    <!-- Productos -->
                    <div class="card_list">
                      <div v-if="productos.length > 0">
                        <div
                          class="card_list_item"
                          v-for="(producto, index) in getProductos"
                          :key="index"
                        >
                          <ProductoSeleccionadoCard
                            :producto="producto"
                          />
                        </div>
                      </div>
                      <div v-else class="loader">{{$t('PRODUCTO_agregar_producto')}}<i class="el-icon-circle-plus"/></div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </transition>

            <div class="totales">
              <el-row>
                <el-col :span="12">
                  <div class="blackLabel col1">{{$t('PEDIDO_subtotal')}}</div>
                </el-col>
                <el-col :span="12">
                  <div class="blackLabel precio">${{ decimalToString(pedido.Subtotal) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PEDIDO_bonificacion')}}</div>
                </el-col>
                <el-col :span="12">
                  <div class="label precio">${{ decimalToString(pedido.Bonificacion) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PEDIDO_porcentaje_descuento')}}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label precio">{{ pedido.DescuentoPorcentaje }}%</div>
                </el-col>
                <el-col :span="8">
                  <div class="label precio">${{ decimalToString(pedido.DescuentoImporte) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PEDIDO_intereses')}}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label precio">{{ pedido.InteresPorcentaje }}%</div>
                </el-col>
                <el-col :span="8">
                  <div class="label precio">${{ decimalToString(pedido.InteresImporte) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="blackLabel col1">{{$t('PEDIDO_neto')}}</div>
                </el-col>
                <el-col :span="12">
                  <div class="blackLabel precio">${{ decimalToString(pedido.ImporteNeto) }}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PEDIDO_iva')}}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label precio">{{ pedido.IVAPorcentaje }}%</div>
                </el-col>
                <el-col :span="8">
                  <div class="label precio">${{ decimalToString(pedido.IVAImporte)}}</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="12">
                  <div class="label col1">{{$t('PEDIDO_iva_reducido')}}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label precio">{{ pedido.IVAReducidoPorcentaje }}%</div>
                </el-col>
                <el-col :span="8">
                  <div class="label precio">${{ decimalToString(pedido.IVAReducidoImporte) }}</div>
                </el-col>
              </el-row>
            </div>

            <el-row class="total">
              <el-col :span="10">
                <div class="label col1">{{$t('PEDIDO_importe_final')}}</div>
              </el-col>
              <el-col :span="14 ">
                <div class="label precio">${{ decimalToString(pedido.ImporteTotal) }} *</div>
              </el-col>
            </el-row>
          </el-card>
          
          <el-row>
            <el-col :span="12" style="text-align: left;" class="label leyenda">
            {{$t('PEDIDO_cantidad_item')}}: {{productos.length}}
          </el-col>
            <el-col 
            :span="12"
            class="label leyenda precio"
            >*{{$t('PEDIDO_sin_impuesto_ingresos_brutos')}}</el-col>
          </el-row>
          <div v-if="existeBaseDolar">
            <el-row >
              <el-col
                class="label leyenda precio"
              >{{$t('PEDIDO_referencia_base_dolar')}}</el-col>
            </el-row>
        </div>
        </div>
      </el-col>
    </el-row>
    <div class="pageFooter">
    <div v-if="estadoProcesoConfirmacion === 0">
      <el-row class="hidden-xs-only">
        <el-col :span="24">
          <el-button style="margin-right: 40px" @click="onClose">{{ $t('GENERAL_cancelBtn') }}</el-button>
          <el-button type="primary" icon="el-icon-edit" @click="onEditarPedido">{{ $t('PEDIDO_editarPedidoBtn') }}</el-button>
          <el-button type="primary" icon="el-icon-check" @click="onConfirmarPedido">{{ $t('PEDIDO_confirmarPedidoBtn') }}</el-button>
        </el-col>
      </el-row>
      <el-row class="hidden-sm-and-up">
          <el-row>
            <el-col :span="12"><el-button style="margin-right: 40px" @click="onClose">{{ $t('GENERAL_cancelBtn') }}</el-button></el-col>
            <el-col :span="12"><el-button type="primary" icon="el-icon-edit" @click="onEditarPedido">{{ $t('PEDIDO_editarPedidoBtn') }}</el-button></el-col>
            <el-col :span="24" class="botonConfirmar"><el-button type="primary" icon="el-icon-check" @click="onConfirmarPedido">{{ $t('PEDIDO_confirmarPedidoBtn') }}</el-button></el-col>
          </el-row>
      </el-row>
    </div>
      <!-- <div v-if="estadoProcesoConfirmacion === 0">
        <el-button style="margin-right: 40px" @click="onClose">{{ $t('GENERAL_cancelBtn') }}</el-button>
        <el-button type="primary" icon="el-icon-edit" @click="onEditarPedido">{{ $t('PEDIDO_editarPedidoBtn') }}</el-button>
        <el-button type="primary" icon="el-icon-check" @click="onConfirmarPedido">{{ $t('PEDIDO_confirmarPedidoBtn') }}</el-button>
      </div> -->
      <div v-else-if="estadoProcesoConfirmacion === 1">
        <el-icon class="el-icon-loading"></el-icon>
        <div class="loadingMsg">{{ $t('PEDIDO_confirmando_pedido') }}</div>
      </div>

      <!-- <div v-else-if="estadoProcesoConfirmacion === 2">
        <div class="pedidoConfirmadoMsg">
          <el-icon class="el-icon-check"></el-icon>
          <span>{{ $t('PEDIDO_confirmado') }}</span>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import ProductoSeleccionadoCard from "@/components/Cards/productoSeleccionadoCard";
  import { decimalToString } from '../Helpers/commonFunctions'
  import { showSuccess } from '../Mensaje'
  import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado'
  import { mapState } from "vuex";

  export default {
    name: "ConfirmarPedido",
    components: {
      ProductoSeleccionadoCard,
    },
    data() {
      return {
        pedido: undefined,
        estadoProcesoConfirmacion: 0,
        productos: [],
        opened: false,
      }
    },
    computed:
    {
      ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      getProductos()
      {
        return this.productos;
      }
    }),

      descripcionInstancia()
      {
        let descripcion = ''

        switch(this.pedido.Instancia)
        {
          case 'A':
            descripcion = this.$t(' PEDIDO_instancia_sin_confirmar')
            break

          case 'B':
            descripcion = this.$t('PEDIDO_instancia_proceso')
            break

          case 'Z':
            descripcion = this.$t('PEDIDO_instancia_historico')
            break

          default:
            descripcion = ''
        }

        return `(${this.pedido.Instancia}) ${descripcion}`
      },
      existeBaseDolar: function() {
        let flag = false;
        this.productos.forEach(producto => {
          if (producto.Moneda != "")
            flag = true;
        });

        return flag;
      }
    },

    methods:
    {
      decimalToString: decimalToString,

      onEditarPedido()
      {
        // recupero el id del pedido
        let idPedido = this.$route.params.id

        // llamo a la edición de pedido
        this.$router.push({ name: "Edicion Pedido", params: { id: idPedido } })
      },

      toggleOpen() {
        this.opened = !this.opened
      },

      onConfirmarPedido()
      {
        // indico que se está confirmando el pedido
        this.estadoProcesoConfirmacion = 1

        // recupero el id del pedido
        let idPedido = this.$route.params.id

        // confirmo el pedido
        this.$store.dispatch('pedidos/confirmarPedido', { id: idPedido })
        .then(data =>
        {
          if(data.CodigoResultado === 0)
          {
            // indico que se confirmó el pedido
            this.estadoProcesoConfirmacion = 2;
            showSuccess(this.$t('PEDIDO_confirmado_success'));
            this.$store.dispatch("pedidos/getPedido", { id: idPedido, idUsuario: this.idUsuario })
              .then(data =>
              {
                if(data.CodigoResultado === 0)
                {
                  var numero = JSON.parse(data.Datos).Numero;
                  // espero X milisegundos y continúo con la ejecución
                  setTimeout(() => this.$router.push({ name: "Pedidos", params: { numeroPedido: numero } }), 2000)
                }
                else
                {
                  mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado);
                }
              })
          }
          else
          {
            mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado)

            // vuelvo al estado inicial de confirmación
            this.estadoProcesoConfirmacion = 0
          }
        })
      },

      onClose()
      {
        // llamo al catálogo de pedidos
        this.$router.push({ name: "Pedidos", params: { keepFilter: true } })
      },

      agregarProductosSeleccionados(productos) {
        productos.forEach(element => {
          this.productos.push(element);
        });
      },

      cargarPedido(pedido) {
        this.pedido = pedido;

        let detalles = pedido.Detalles.map(x => {
          return {
            ...x,
            Bonificacion: x.BonificacionPorcentaje,
            Nombre: x.Producto.Clave,
            Clave: x.Producto.Clave,
            Descripcion: x.Producto.Descripcion
          };
        });
        this.agregarProductosSeleccionados(detalles);
        }

    },

    mounted()
    {
      // busco la cabecera del pedido a confirmar
      let idPedido = this.$route.params.id

      /*this.$store.dispatch('pedidos/getCabeceraPedido', { id: idPedido, idUsuario : this.idUsuario })
      .then((data) =>
      {
        if(data.CodigoResultado === 0)
        {
          this.pedido = JSON.parse(data.Datos)
        }
        else
        {
          mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado)
        }
      })*/

      // busco el Pedido
      this.$store
        .dispatch("pedidos/getPedido", { id: idPedido, idUsuario: this.idUsuario })
        .then(data => {
          if (data.CodigoResultado === 0) {
            var pedido = JSON.parse(data.Datos);
            this.cargarPedido(pedido);
          } else {
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
          }
        })
        .finally(() => {
          this.loading = false;
          this.inicializandoPedido = false;
        });
    }
  }

</script>

<style scoped>

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 26px;
    padding: 0 0 7px;
  }

  .triangleRight,
  .triangleDown {
    width: 0;
    height: 0;
    border-style: solid;
    cursor: pointer;
  }
  .triangleRight {
    border-width: 8px 0 8px 13.9px;
    border-color: transparent transparent transparent var(--main-color);
  }
  .triangleDown {
    border-width: 13.9px 8px 0 8px;
    border-color: var(--main-color) transparent transparent transparent;
  }
  .detalle_pedido {
    padding: 15px;
  }

  .subtitulo {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    color: #999;
  }
  .cabecera .subtitulo {
    font-size: 16px;
  }
  .sub-title {
    padding: 3px 0px 10px 0px;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
  }

  .label {
    font-size: 14px;
    text-align: left;
    padding: 10px 0px;
  }
  .label.col1 {
    margin-left: 15px;
    justify-content: center;
  }
  .greyLabel {
    color: #6b6b6b;
    font-weight: normal;
    padding: 10px 0px;
    text-align: left;
  }
  .blackLabel {
    text-align: left;
    margin: 12px 0 4px 15px;
    justify-content: center;
    font-weight: bold;
  }

  .el-divider {
    margin: 2px 0 2px 0;
  }

  .totales {
    background: rgba(233, 233, 233, 0.959);
    padding: 0 20px 10px;
  }

  .contenedores {
    margin: 0px 20px 0 0;
  }

  .precio {
    text-align: right;
  }

  .total {
    background-color: var(--main-color);
    color: #ffffff;
    font-weight: bold;
    padding: 0 20px 10px;
  }

  .total .label {
    font-size: 1.5em;
  }

  .pageFooter {
    margin-top: 40px;
  }

  .pageFooter i {
    font-size: 40px;
    color: var(--main-color);
  }

  .pageFooter .loadingMsg {
    font-size: 12px;
    color: var(--main-color);
    margin-top: 5px;
  }



  .pageFooter .pedidoConfirmadoMsg,
  .pageFooter .pedidoConfirmadoMsg i {
    color: #4CAF50;
    font-size: 20px;
  }

  .pageFooter .pedidoConfirmadoMsg i {
    margin-right: 10px;
  }
  @media (max-width: 600px) {
    .botonConfirmar{
      margin-top: 10px;
    }
  }

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>